import { changeScreen, changeScreenB, changeScreenC } from '../../../store/actions/navigation.action'
import { useDispatch, useSelector } from 'react-redux'
import { Drawer } from '@material-ui/core'
import AccountEdit from '../account/edit'
import CampaignEdit from '../campaigns/edit'
import Raffle from '../campaigns/raffle'
import Roulette from '../roulette'
import RouletteEdit from '../roulette/edit'
import CotaPremiada from '../premiada'
import ChartAccount from '../account/chart'
import ChartAfiliado from '../afiliados/chart'
import ChartGestor from '../gestor/chart'
import ChartCampaign from '../campaigns/chart/campaign'
import ChartCampaigns from '../campaigns/chart'
import ChartLinks from '../links/chart'
import ChartLink from '../links/chart/link'
import CotaPremiadaEdit from '../premiada/edit'
import MercadopagoEdit from '../mercadopago/edit'
import Top from '../top'
import Metrics from '../metrics'
import MetricsRegion from '../metrics/region'
import Cupons from '../cupons'
import CuponsEdit from '../cupons/edit'
import Menor from '../menor'
import Transactions from '../transactions'
import Links from '../links'
import LinksEdit from '../links/edit'
import PixelEdit from '../pixel/edit'
import GoogleEdit from '../google/edit'
import AfiliadosEdit from '../afiliados/edit'
import AfiliadosPassword from '../afiliados/password'
import AfiliadosAccess from '../afiliados/access'
import GestorEdit from '../gestor/edit'
import GestorPassword from '../gestor/password'
import GestorAccess from '../gestor/access'
import WebhookEdit from '../webhooks/edit'
import NotificationCreate from '../notifications/create'
import Consult from '../consult'
import Profile from '../users/profile'
import Shopping from '../shopping'
import Prizes from '../instant-prizes'
import EditPrizes from '../instant-prizes/edit'

import MenorGestao from '../menor/setting'
import MenorGestaoCreate from '../menor/setting/create'
import MenorGestaoEdit from '../menor/setting//edit'


const style = {
    width: '680px',
    maxWidth: window.innerWidth
}

export default function Navigation(props) {
    const dispatch = useDispatch()
    const nav = useSelector(state => state.navigationReducer)

    return (
        <>
            <Drawer 
                anchor="right"
                open={nav.screen.open}
                onClose={() => dispatch(changeScreen({ open: false }))}
            >
                <div className="max-width page" style={style}>
                    {(nav.screen.type === 'mercadopago-edit') &&
                        <MercadopagoEdit />
                    }
                    {(nav.screen.type === 'account-create' || nav.screen.type === 'account-edit') &&
                        <AccountEdit
                            uid={nav.screen.props.uid}
                            gateway={nav.screen.props.gateway}
                        />
                    }
                    {(nav.screen.type === 'pixel-create' || nav.screen.type === 'pixel-edit') &&
                        <PixelEdit
                            uid={nav.screen.props.uid}
                        />
                    }
                    {(nav.screen.type === 'google-create' || nav.screen.type === 'google-edit') &&
                        <GoogleEdit
                            uid={nav.screen.props.uid}
                        />
                    }
                    {(nav.screen.type === 'notification-create') &&
                        <NotificationCreate
                            uid={nav.screen.props.uid}
                        />
                    }
                    {(nav.screen.type === 'afiliado-create' || nav.screen.type === 'afiliado-edit') &&
                        <AfiliadosEdit
                            uid={nav.screen.props.uid}
                        />
                    }
                    {(nav.screen.type === 'afiliado-password') &&
                        <AfiliadosPassword
                            uid={nav.screen.props.uid}
                        />
                    }
                    {(nav.screen.type === 'afiliado-access') &&
                        <AfiliadosAccess
                            uid={nav.screen.props.uid}
                        />
                    }
                    {(nav.screen.type === 'gestor-create' || nav.screen.type === 'gestor-edit') &&
                        <GestorEdit
                            uid={nav.screen.props.uid}
                        />
                    }
                    {(nav.screen.type === 'gestor-password') &&
                        <GestorPassword
                            uid={nav.screen.props.uid}
                        />
                    }
                    {(nav.screen.type === 'gestor-access') &&
                        <GestorAccess
                            uid={nav.screen.props.uid}
                        />
                    }
                    {(nav.screen.type === 'webhook-create' || nav.screen.type === 'webhook-edit') &&
                        <WebhookEdit
                            uid={nav.screen.props.uid}
                        />
                    }
                    {(nav.screen.type === 'campaign-edit' || nav.screen.type === 'campaign-create') &&
                        <CampaignEdit 
                            uid={nav.screen.props.uid}
                        />
                    }
                    {(nav.screen.type === 'raffle') &&
                        <Raffle 
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'roulette') &&
                        <Roulette 
                            uid={nav.screen.props.uid}
                        />
                    }
                    
                    {(nav.screen.type === 'cota-premiada') &&
                        <CotaPremiada 
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'instant-prizes') &&
                        <Prizes 
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'search-cota') &&
                        <Consult 
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'profile') &&
                        <Profile
                            screen="a"
                            user_id={nav.screen.props.user_id}
                        />
                    }

                    {(nav.screen.type === 'shopping') &&
                        <Shopping
                            screen="a"
                            user_id={nav.screen.props.user_id}
                        />
                    }

					{(nav.screen.type === 'campaign-top') &&
                        <Top
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'metrics') &&
                        <Metrics 
                            uid={nav.screen.props.uid}
                            afiliado_id={nav.screen.props.afiliado_id}
                        />
                    }

                    {(nav.screen.type === 'metrics-region') &&
                        <MetricsRegion 
                            uid={nav.screen.props.uid}
                            afiliado_id={nav.screen.props.afiliado_id}
                        />
                    }

                    {(nav.screen.type === 'cupons') &&
                        <Cupons 
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'menor') &&
                        <Menor 
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'transactions') &&
                        <Transactions 
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'links') &&
                        <Links 
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'chart-campaign') &&
                        <ChartCampaign 
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'chart-account') &&
                        <ChartAccount 
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'chart-afiliado') &&
                        <ChartAfiliado
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'chart-gestor') &&
                        <ChartGestor
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'chart-campaigns') &&
                        <ChartCampaigns 
                            uid={nav.screen.props.uid}
                        />
                    }
                </div>
            </Drawer>

            <Drawer 
                anchor="right"
                open={nav.screenB.open}
                onClose={() => dispatch(changeScreenB({ open: false }))}
            >
                <div className="max-width" style={style}>

                    {(nav.screenB.type === 'shopping') &&
                        <Shopping
                            screen="b"
                            user_id={nav.screenB.props.user_id}
                        />
                    }

                    {(nav.screenB.type === 'roulette-create' || nav.screenB.type === 'roulette-edit') &&
                        <RouletteEdit
                            uid={nav.screenB.props.uid}
                            campaign_id={nav.screenB.props.campaign_id}
                        />
                    }

                    {(nav.screenB.type === 'cota-premiada-create' || nav.screenB.type === 'cota-premiada-edit') &&
                        <CotaPremiadaEdit
                            uid={nav.screenB.props.uid}
                            editor={nav.screenB.props.editor}
                            campaign_id={nav.screenB.props.campaign_id}
                        />
                    }

                    {(nav.screenB.type === 'instant-prizes-create' || nav.screenB.type === 'instant-prizes-edit') &&
                        <EditPrizes
                            uid={nav.screenB.props.uid}
                            editor={nav.screenB.props.editor}
                            campaign_id={nav.screenB.props.campaign_id}
                        />
                    }

                    {(nav.screenB.type === 'cupons-create' || nav.screenB.type === 'cupons-edit') &&
                        <CuponsEdit
                            uid={nav.screenB.props.uid}
                            campaign_id={nav.screenB.props.campaign_id}
                        />
                    }

                    {(nav.screenB.type === 'links-create' || nav.screenB.type === 'links-edit') &&
                        <LinksEdit
                            uid={nav.screenB.props.uid}
                            campaign_id={nav.screenB.props.campaign_id}
                        />
                    }

                    {(nav.screenB.type === 'metrics') &&
                        <Metrics 
                            uid={nav.screenB.props.uid}
                            link_id={nav.screenB.props.link_id}
                            afiliado_id={nav.screenB.props.afiliado_id}
                        />
                    }

                    {(nav.screenB.type === 'transactions') &&
                        <Transactions 
                            uid={nav.screenB.props.uid}
                            user_id={nav.screenB.props.user_id}
                            link_id={nav.screenB.props.link_id}
                        />
                    }

                    {(nav.screenB.type === 'chart-links') &&
                        <ChartLinks 
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screenB.type === 'chart-link') &&
                        <ChartLink
                            uid={nav.screenB.props.uid}
                            campaign_id={nav.screenB.props.campaign_id}
                        />
                    }

                    {(nav.screenB.type === 'menor-gestao') &&
                        <MenorGestao
                            campaign_id={nav.screenB.props.campaign_id}
                        />
                    }
                </div>
            </Drawer>

            <Drawer 
                anchor="right"
                open={nav.screenC.open}
                onClose={() => dispatch(changeScreenC({ open: false }))}
            >
                <div className="max-width" style={style}>
                    {(nav.screenC.type === 'transactions') &&
                        <Transactions
                            screen="c"
                            uid={nav.screenC.props.uid}
                            user_id={nav.screenC.props.user_id}
                            link_id={nav.screenC.props.link_id}
                        />
                    }

                    {(nav.screenC.type === 'menor-gestao-create') &&
                        <MenorGestaoCreate
                            campaign_id={nav.screenC.props.campaign_id}
                            view={nav.screenC.props.view}
                        />
                    }

                    {(nav.screenC.type === 'menor-gestao-edit') &&
                        <MenorGestaoEdit
                            uid={nav.screenC.props.uid}
                            campaign_id={nav.screenC.props.campaign_id}
                            view={nav.screenC.props.view}
                        />
                    }
                </div>
            </Drawer>
        </>
    )
}